var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 173,
    viewBox: "0 0 203 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.252 94.5254H150.748V101.732H52.252V94.5254Z",
    fill: "url(#paint0_radial_16_735)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5 70.7973C105.078 69.5135 107.506 66.119 107.506 62.251V59.0381L101.5 56.7859L95.4941 59.0381V62.251C95.4941 66.1192 97.9219 69.5135 101.5 70.7973Z",
    fill: "url(#paint1_linear_16_735)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1906 108.939C57.2707 120.384 68.1101 128.158 80.4704 128.158H122.53C134.89 128.158 145.729 120.384 149.809 108.939H53.1906Z",
    fill: "url(#paint2_radial_16_735)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.686 87.3184C156.006 87.3184 160.742 83.8326 162.204 78.7168C162.728 76.8857 163 74.9668 163 73.0045C163 66.196 159.656 59.8358 154.055 55.9911C143.636 48.8396 122.954 36.8418 101.5 36.8418C80.0459 36.8418 59.3639 48.8396 48.9451 55.9914C43.3441 59.8361 40 66.1963 40 73.0048C40 74.967 40.2724 76.886 40.7957 78.7171C42.2577 83.8328 46.9937 87.3187 52.3142 87.3187H150.686V87.3184ZM88.2871 56.541C88.2871 55.0391 89.219 53.6942 90.6253 53.1669L100.235 49.5634C101.05 49.2576 101.95 49.2576 102.765 49.5634L112.374 53.1669C113.781 53.6942 114.713 55.0388 114.713 56.541V62.2511C114.713 69.7397 109.639 76.2383 102.374 78.0545C102.087 78.1261 101.793 78.1621 101.5 78.1621C101.206 78.1621 100.913 78.1263 100.626 78.0545C93.3611 76.2381 88.2871 69.7397 88.2871 62.2511V56.541Z",
    fill: "url(#paint3_radial_16_735)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_735",
    x: 0,
    y: -15,
    width: 203,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_735"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_735",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16_735",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.1358 95.2816) rotate(90) scale(8.65625 118.302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_735",
    x1: 93.1656,
    y1: 56.806,
    x2: 105.375,
    y2: 65.2109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#02A3F1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_16_735",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.2761 110.956) rotate(90) scale(23.0833 116.047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16_735",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.3037 42.1385) rotate(90) scale(60.6269 147.733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.ea8ac8f94ac007c78e7fb8ec77abdbd2.svg";
export { ForwardRef as ReactComponent };